import {h, reactive, VNode, watch} from "vue";
import {UserAgent} from "@/model/user_agent";
import dayjs from "dayjs";
import {Tooltip} from "ant-design-vue";
import {InfoCircleOutlined} from "@ant-design/icons-vue";
import {api} from "@/lib/api";

export type TServiceType =
    '基础版会员'
    | '专业版会员'
    | '旗舰版会员'
    | '订制元素'
    | '代制作'
    | '在线操盘'
    | '自定义广告'
    | '自定义广告x4'
    | '自定义广告x6'
    | '自定义广告x10'
    | '订制主题'

export interface IAgentCoupon {
    coupon_id: string
    agent_id: string
    target: TServiceType
    name: string
    amount: number
    expiration: string
    service_order_id: string | null
}

export class ServiceOrder {
    readonly data = reactive({
        title: '',
        info: {title: '', description: '', tags: ['专属内容']},
        coupons: [] as IAgentCoupon[],
        coupon: null as null | IAgentCoupon,
        attach: {
            acid: null as null | string,
            aid: '',
            cid: null as null | string,
            s: '基础版会员' as TServiceType
        },
        price: {original: 100, deduction: 10, price: 0},
        step_items: [{title: '', description: '' as string | VNode}],
        step_current: 1,
        qr: {code: '', status: '', description: ''},
    })

    constructor(public readonly serviceType: TServiceType, private readonly userAgent: UserAgent, private readonly activity_id?: string) {
        this.data.price = {
            original: this.userAgent.meta.service[serviceType].original,
            deduction: this.userAgent.meta.service[serviceType].deduction,
            price: 98
        };
        this.data.coupons = this.userAgent.meta.coupons.filter(item => item.target === this.serviceType && item.service_order_id === null && dayjs(item.expiration).isAfter(dayjs())).sort((a, b) => b.amount - a.amount);
        if (this.data.coupons.length > 0) {
            this.data.attach.cid = this.data.coupons[0].coupon_id
            this.data.coupon = this.data.coupons[0]
        }
        this.data.price.price = this.data.price.original - this.data.price.deduction - (this.data.coupon?.amount ?? 0)
        this.data.attach.aid = this.userAgent.meta.account.agent_id
        this.data.attach.s = serviceType

        switch (this.serviceType) {
            case "订制元素":
                this.setCustomElement();
                break;
            case "自定义广告":
            case "自定义广告x4":
            case "自定义广告x6":
            case "自定义广告x10":
                this.setCustomAD()
                break;
            default:
                throw Error('不支持的类型')
        }
        watch(() => this.data.attach.cid, () => {
            this.data.price.price = this.data.price.original - this.data.price.deduction - (this.data.coupon?.amount ?? 0)
            this.data.price.price = this.data.price.price <= 1 ? 1 : this.data.price.price
            this.loadQR()
        })
    }

    private setCustomElement() {
        this.data.title = '订制元素服务单'
        this.data.info = {
            title: '订制元素服务',
            description: '根据您的需求个性化设计、修改图片中的特定部分，如LOGO、图标、文字等，确保风格与用途完美匹配。',
            tags: ['人工订做', '一对一服务']
        };

        if (!this.activity_id) throw Error('请先保存活动')
        this.data.attach.acid = this.activity_id

        this.data.step_items = [
            {
                title: '下单',
                description: '支付服务费用',
            },
            {
                title: '咨询客服',
                description: h(Tooltip, {}, {
                    default: () => ['微信客服 ', h(InfoCircleOutlined)],
                    title: () => h('img', {src: require('@/assets/image/customer_service_qr.jpg'), width: '128px'})
                }),
            },
            {
                title: '制作',
                description: '客服代排班',
            },
            {
                title: '使用',
                description: '直接使用',
            },
        ]
        this.data.step_current = 0
        this.data.qr = {code: '', status: 'loading', description: '支付成功后，系统将自动为您创建业务单并通知客服。'}

        this.loadQR()
    }

    private setCustomAD() {
        this.data.title = '自定义广告服务单'
        this.data.info = {
            title: '自定义广告服务',
            description: '自动捕捉门店活动中的高意向客户，将精准商机一键推送给您，让潜在客户主动找上门，大幅提升您的获客效率。',
            tags: ['精准获客', '高效转化', '需求直连']
        };
        this.data.step_items = [
            {
                title: '下单',
                description: '支付服务费用',
            },
            {
                title: '发布活动',
                description: '扣1次，开始获客',
            },
            {
                title: '使用',
                description: '直接使用',
            },
        ]
        this.data.step_current = 0
        this.data.qr = {code: '', status: 'loading', description: '支付成功后，发布活动后生效。'}

        this.loadQR()
    }

    couponPick(coupon_id: string) {
        for (const coupon of this.data.coupons) {
            if (coupon.coupon_id === coupon_id) {
                if (this.data.coupon?.coupon_id === coupon_id) {
                    this.data.coupon = null
                    this.data.attach.cid = null
                } else {
                    this.data.coupon = coupon
                    this.data.attach.cid = coupon_id
                }

            }
        }
    }

    private loadQR() {
        this.data.qr.status = 'loading'
        api<void, any>({url: `user/${this.userAgent.meta.account.agent_id}/order`, method: 'POST', data: this.data.attach}).then(res => {
            this.data.qr.code = res.code_url
            this.data.qr.status = 'active'
        }).catch(err => {
            this.data.qr.status = 'expire'
            console.log(err)
        })
    }
}